import { isBefore, format, isWeekend } from "date-fns";
import { APP_DATE_FORMAT } from "../constants";
const isPastDate = (date, terminalCurrentDate) => {
  return isBefore(date, terminalCurrentDate);
};
const isHoliday = (date, holidays) => {
  const holidayDates = holidays.map((holiday) => holiday.holidayDate);
  return (
    holidayDates.includes(format(date, APP_DATE_FORMAT)) || isWeekend(date)
  );
};

const getHolidayName = (date, holidays) => {
  return holidays.find(
    (holiday) => holiday.holidayDate === format(date, APP_DATE_FORMAT)
  )?.holidayName;
};

const checkPlanAlreadyInitialized = (date, initializedDates) => {
  return initializedDates.some(
    (initializedDate) =>
      initializedDate.planDate === format(date, APP_DATE_FORMAT)
  );
};

const getPlanDateIBEtaCutOff = (initializedDates,planDate) => {
  return initializedDates.find(
    (initializedDate) => initializedDate.planDate === planDate
  )?.ibEtaCutOff;
}

export {
  isPastDate,
  isHoliday,
  getHolidayName,
  checkPlanAlreadyInitialized,
  getPlanDateIBEtaCutOff,
};
